"use strict";

var _slicedToArray = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Close = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery/useMediaQuery"));
var _ReportProblemOutlined = _interopRequireDefault(require("@material-ui/icons/ReportProblemOutlined"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _SimpleTable = _interopRequireDefault(require("./SimpleTable"));
var _OfferContactUsThankyou = _interopRequireDefault(require("./OfferContactUsThankyou"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
/* eslint complexity: 0 */

var LeftArrowIcon = (0, _helpers.getImageByAgent)('left-arrow.svg');
var PdfFileIcon = (0, _helpers.getImageByAgent)('pdf-file.svg');
var MinusIcon = (0, _helpers.getImageByAgent)('minus-icon.svg');
var useStyles = (0, _core.makeStyles)(function (theme) {
  var _div, _offerFooter;
  return {
    column: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      minWidth: 120
    }, theme.breakpoints.down(970), {
      minWidth: 75
    }),
    content: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      padding: '10px 2px'
    },
    covers: {
      '& .attention': {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.pxToRem(11.4)
      },
      '& .attention-title': {
        '& svg': {
          color: _helpers.agentDeveloperUtils.getPrimaryColor(450)
        },
        alignItems: 'center',
        color: theme.palette.text.secondary,
        display: 'flex',
        fontSize: theme.typography.pxToRem(12.25),
        fontWeight: 'Bold',
        marginBottom: 5
      },
      '& .covers-table': {
        marginBottom: '40px'
      },
      '& .pdf-button': {
        '& img': {
          marginRight: 10
        },
        backgroundClip: 'padding-box',
        backgroundColor: theme.palette.background.paper,
        backgroundOrigin: 'padding-box',
        backgroundPosition: '0% 0%',
        backgroundRepeat: 'no-repeat',
        border: '1px solid #D8EAF1',
        borderRadius: 8,
        boxShadow: '0px 1px 3px #0000000F',
        display: 'flex',
        fontSize: theme.typography.pxToRem(12.25),
        height: 36,
        justifyContent: 'center',
        margin: 0,
        padding: '5px 10px',
        width: 183
      },
      '& .protection': {
        '& .p-title': {
          color: theme.palette.secondary.dark,
          fontSize: theme.typography.pxToRem(15.75),
          fontWeight: 'bold',
          marginBottom: 5
        },
        marginBottom: 10
      },
      '& .table-title': {
        color: theme.palette.secondary.dark,
        fontSize: theme.typography.pxToRem(15.75),
        fontWeight: 'bold',
        margin: '20px 0'
      }
    },
    coversButton: {
      '& .info': {
        '&:hover': {
          textDecoration: 'underline'
        },
        color: theme.palette.secondary.main
      },
      '& img': {
        '&.rotate': {
          transform: 'rotate(180deg)'
        },
        transition: '0.3s all'
      },
      '&:hover': {
        backgroundColor: 'unset',
        boxShadow: 'unset'
      },
      backgroundColor: 'transparent',
      boxShadow: 'unset',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(12.25),
      lineHeight: 1,
      margin: 'unset',
      padding: 'unset',
      transition: '0.3s all'
    },
    hide: {
      display: 'none !important'
    },
    left: {
      '& > div': (_div = {
        '& .string': {
          fontSize: theme.typography.pxToRem(12.25)
        },
        '& span': _defineProperty({
          display: 'inline-block',
          fontSize: theme.typography.pxToRem(21)
        }, theme.breakpoints.down(970), {
          display: 'block',
          fontSize: theme.typography.pxToRem(18.4)
        }),
        borderLeft: "2px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
        color: theme.palette.text.secondary,
        flex: '0 1 auto',
        fontSize: theme.typography.pxToRem(19.25),
        fontWeight: 700,
        lineHeight: 1
      }, _defineProperty(_div, theme.breakpoints.down(970), {
        fontSize: theme.typography.pxToRem(12.25)
      }), _defineProperty(_div, "maxWidth", 135), _defineProperty(_div, "textAlign", 'center'), _div),
      borderRadius: '0 10px 0 0',
      display: 'flex',
      flex: '0 1 auto',
      overflow: 'hidden'
    },
    right: {
      '& .offer-footer': (_offerFooter = {
        '& .disclaimer': _defineProperty({
          '& > span': {
            background: "".concat(_helpers.agentDeveloperUtils.getSecondaryColor(180), " 0% 0% no-repeat padding-box")
          },
          color: theme.palette.secondary.darkLight,
          flex: '1 1 100%',
          fontSize: 14,
          fontWeight: 500,
          letterSpacing: 0,
          marginLeft: 10
        }, theme.breakpoints.down(769), {
          fontSize: 12,
          margin: [[0, 0, 0, 10]]
        }),
        '& .protection-title': {
          '& > span': {
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          },
          '&::before': {
            color: theme.palette.primary.main,
            content: '"*"',
            fontSize: theme.typography.pxToRem(23.6),
            marginRight: 6,
            paddingTop: 5,
            pointerEvents: 'none'
          },
          alignItems: 'center',
          display: 'flex',
          flex: '1 1 100%',
          fontSize: theme.typography.pxToRem(12.25),
          fontWeight: '500',
          lineHeight: '15px',
          margin: '0 12px 0 20px',
          maxHeight: 30,
          minWidth: 85
        },
        '& .protection-title-simulator': {
          '& > span': {
            display: 'inline-block',
            overflow: 'unset',
            textOverflow: 'unset',
            whiteSpace: 'break-spaces'
          },
          '&::before': {
            color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
            content: '"*"',
            fontSize: theme.typography.pxToRem(23.6),
            marginRight: 6,
            paddingTop: 5,
            pointerEvents: 'none'
          },
          alignItems: 'center',
          display: 'flex',
          flex: '1 1 100%',
          fontSize: theme.typography.pxToRem(12.25),
          fontWeight: '500',
          lineHeight: '15px',
          margin: '0 12px 0 20px',
          maxHeight: 30,
          minWidth: 85
        },
        '& .tag-labels': {
          background: '#00A9E926',
          borderRadius: '5px',
          color: theme.palette.secondary.main,
          flex: '0 0 auto',
          padding: '0 10px',
          width: 122
        },
        '& img': {
          marginRight: 6
        }
      }, _defineProperty(_offerFooter, theme.breakpoints.down(420), {
        padding: '3px 6px'
      }), _defineProperty(_offerFooter, "alignItems", 'center'), _defineProperty(_offerFooter, "borderTop", "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100))), _defineProperty(_offerFooter, "color", theme.palette.text.secondary), _defineProperty(_offerFooter, "display", 'flex'), _defineProperty(_offerFooter, "fontSize", theme.typography.pxToRem(12.25)), _defineProperty(_offerFooter, "justifyContent", 'space-between'), _defineProperty(_offerFooter, "minHeight", 40), _defineProperty(_offerFooter, "padding", '3px 15px'), _offerFooter),
      flex: '1 1 auto'
    },
    root: {
      '& .best-offer-label': {
        backgroundColor: theme.palette.background.paper,
        border: "1px solid ".concat(theme.palette.primary.main),
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        color: theme.palette.secondary.main,
        cursor: 'default',
        fontSize: theme.typography.pxToRem(12.25),
        fontWeight: 700,
        left: 20,
        padding: '6px 16px',
        position: 'absolute',
        top: -5,
        zIndex: 1
      },
      '& .wrapper': {
        '&.show-border-bottom': {
          borderBottom: '1px solid #D8EAF1'
        },
        borderColor: '#D8EAF1',
        borderWidth: '1px',
        display: 'flex'
      },
      '&.mobile': {
        '& .best-offer-label': _defineProperty({
          borderWidth: 2,
          left: 'unset',
          right: 'calc(25% - 72px)',
          transform: 'unset'
        }, theme.breakpoints.down(420), {
          fontSize: theme.typography.pxToRem(10.5),
          padding: '6px 10px',
          right: 'calc(25% - 33px)'
        }),
        '& .offer-footer': {
          minHeight: 30
        },
        '& .offer-footer .tag-labels': {
          fontSize: theme.typography.pxToRem(10.5),
          margin: 0,
          textAlign: 'center',
          width: 110
        },
        '& div.offer-footer button': {
          '& .info': {
            whiteSpace: 'nowrap'
          },
          '& img': {
            marginRight: 5
          },
          fontSize: theme.typography.pxToRem(10.5),
          width: 131
        }
      },
      '&.open': {
        boxShadow: '0px 1px 3px rgba(0,0,0,0.2)'
      },
      backgroundColor: theme.palette.background.paper,
      border: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
      borderRadius: 10,
      position: 'relative',
      width: '100%'
    },
    slot: {
      position: 'relative'
    },
    title: _defineProperty({
      alignItems: 'center',
      backgroundColor: _helpers.agentDeveloperUtils.getConvertedColor('#F3913112'),
      color: theme.palette.primary.main,
      display: 'flex',
      fontSize: theme.typography.pxToRem(13.125),
      height: 40,
      justifyContent: 'center',
      lineHeight: 1,
      padding: 3
    }, theme.breakpoints.down(970), {
      fontSize: theme.typography.pxToRem(12.25)
    })
  };
});
var Offer = function Offer(_ref) {
  var _ref$bestOfferBadgeTe = _ref.bestOfferBadgeText,
    bestOfferBadgeText = _ref$bestOfferBadgeTe === void 0 ? 'מקום 1 במחיר' : _ref$bestOfferBadgeTe,
    children = _ref.children,
    data = _ref.data,
    titles = _ref.titles,
    titlesSecondary = _ref.titlesSecondary,
    isOpen = _ref.isOpen,
    _ref$isBestOffer = _ref.isBestOffer,
    isBestOffer = _ref$isBestOffer === void 0 ? false : _ref$isBestOffer,
    showContactUs = _ref.showContactUs,
    _ref$showProtectionTi = _ref.showProtectionTitle,
    showProtectionTitle = _ref$showProtectionTi === void 0 ? true : _ref$showProtectionTi,
    tags = _ref.tags,
    extraPrimaryCovers = _ref.extraPrimaryCovers,
    expandCoversHandler = _ref.expandCoversHandler,
    pdfLinkHandler = _ref.pdfLinkHandler,
    closeContactUsHandler = _ref.closeContactUsHandler,
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'shekel' : _ref$currency,
    noLeft = _ref.noLeft,
    simulator = _ref.simulator,
    shouldFilterEmptyCovers = _ref.shouldFilterEmptyCovers;
  var classes = useStyles();
  var isMobile = (0, _useMediaQuery.default)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  var isDownMB = (0, _useMediaQuery.default)('(max-width:969px)');

  // State
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    isCoversOpen = _react$default$useSta2[0],
    setIsCoverOpen = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    isCoversSecondaryOpen = _react$default$useSta4[0],
    setIsCoverSecondaryOpen = _react$default$useSta4[1];
  var _react$default$useSta5 = _react.default.useState(false),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    showBorderBottom = _react$default$useSta6[0],
    setShowBorderBottom = _react$default$useSta6[1];
  var _react$default$useSta7 = _react.default.useState([]),
    _react$default$useSta8 = _slicedToArray(_react$default$useSta7, 2),
    covers = _react$default$useSta8[0],
    setCovers = _react$default$useSta8[1];
  var _react$default$useSta9 = _react.default.useState([]),
    _react$default$useSta10 = _slicedToArray(_react$default$useSta9, 2),
    coversSecondary = _react$default$useSta10[0],
    setCoversSecondary = _react$default$useSta10[1];
  var _react$default$useSta11 = _react.default.useState([]),
    _react$default$useSta12 = _slicedToArray(_react$default$useSta11, 2),
    coversExtraPrime = _react$default$useSta12[0],
    setCoversExtraPrime = _react$default$useSta12[1];
  var showWhenOpen = function showWhenOpen() {
    if (isOpen) {
      return '';
    }
    return classes.hide;
  };
  var mobileOnly = function mobileOnly() {
    if (isMobile) {
      return '';
    }
    return classes.hide;
  };
  (0, _react.useEffect)(function () {
    if (data.insuranceCovers && data.insuranceCovers.length) {
      var simpleCovers = [];
      var extraCovers = [];
      data.insuranceCovers.forEach(function (cover) {
        if (shouldFilterEmptyCovers && !cover.text) {
          return;
        }
        var array = cover.extra ? extraCovers : simpleCovers;
        array.push({
          title: cover.title,
          value: cover.text
        });
      });
      setCovers(simpleCovers);
      setCoversExtraPrime(extraCovers);
    } else if (!covers.length) {
      setCovers(Object.entries(titles).reduce(function (accumulator, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          index = _ref3[0],
          title = _ref3[1];
        // SKIP extra primary covers
        if (extraPrimaryCovers && Array.isArray(data.covers[index]) && data.covers[index][1] === true) {
          return accumulator;
        }
        if (shouldFilterEmptyCovers && !data.covers[index]) {
          return accumulator;
        }
        accumulator.push({
          title: title,
          value: data.covers[index]
        });
        return accumulator;
      }, []));
      setCoversExtraPrime(Object.entries(titles).reduce(function (accumulator, _ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          index = _ref5[0],
          title = _ref5[1];
        // SET extra primary covers ONLY
        if (extraPrimaryCovers && Array.isArray(data.covers[index]) && data.covers[index][1] === true) {
          if (shouldFilterEmptyCovers && !data.covers[index][0]) {
            return accumulator;
          }
          accumulator.push({
            title: title,
            value: data.covers[index][0]
          });
        }
        return accumulator;
      }, []));
    }
  }, [titles, data.covers, data.insuranceCovers]);
  (0, _react.useEffect)(function () {
    if (!coversSecondary.length && titlesSecondary) {
      setCoversSecondary(Object.entries(titlesSecondary).reduce(function (accumulator, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
          index = _ref7[0],
          title = _ref7[1];
        if (shouldFilterEmptyCovers && !data.coversSecondary[index]) {
          return accumulator;
        }
        accumulator.push({
          title: title,
          value: data.coversSecondary[index]
        });
        return accumulator;
      }, []));
    }
  }, [titlesSecondary]);
  (0, _react.useEffect)(function () {
    if (!isOpen && isCoversOpen) {
      setIsCoverOpen(false);
    }
    if (!isOpen && isCoversSecondaryOpen) {
      setIsCoverSecondaryOpen(false);
    }
  }, [isOpen]);
  var handleCoversClick = function handleCoversClick() {
    var open = !isCoversOpen;
    if (open) {
      if (expandCoversHandler) {
        expandCoversHandler();
      }
      setShowBorderBottom(true);
    } else {
      setTimeout(function () {
        setShowBorderBottom(false);
      }, 300);
    }
    setIsCoverOpen(open);
  };
  var handleCoversSecondaryClick = function handleCoversSecondaryClick() {
    var open = !isCoversSecondaryOpen;
    if (open) {
      setShowBorderBottom(true);
    } else {
      setTimeout(function () {
        setShowBorderBottom(false);
      }, 300);
    }
    setIsCoverSecondaryOpen(open);
  };
  var getRightSideWidth = function getRightSideWidth(breakpoint) {
    if (breakpoint) {
      return "calc(100% - ".concat(75 * data.additionalPrices.length, "px)");
    }
    return "calc(100% - ".concat(120 * data.additionalPrices.length, "px)");
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    name: "offerContentContainer",
    className: "".concat(classes.root, " ").concat(isMobile ? 'mobile' : '', " ").concat(isOpen ? 'open' : '')
  }, isBestOffer ? /*#__PURE__*/_react.default.createElement("span", {
    className: "best-offer-label"
  }, bestOfferBadgeText) : false, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper ".concat(showBorderBottom ? 'show-border-bottom' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.right,
    style: {
      width: getRightSideWidth(isDownMB)
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.slot
  }, children, /*#__PURE__*/_react.default.createElement(_OfferContactUsThankyou.default, {
    data: data,
    showContactUs: showContactUs,
    closeContactUsHandler: closeContactUsHandler
  })), titlesSecondary ? /*#__PURE__*/_react.default.createElement("div", {
    className: "offer-footer ".concat(showWhenOpen())
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "text",
    onClick: handleCoversSecondaryClick,
    className: classes.coversButton
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: isCoversSecondaryOpen ? MinusIcon : LeftArrowIcon,
    className: isCoversSecondaryOpen ? 'rotate' : '',
    alt: "left-arrow"
  }), /*#__PURE__*/_react.default.createElement("span", null, "\u05E4\u05E8\u05D8\u05D9 \u05D4\u05D4\u05E6\u05E2\u05D4")), tags && Boolean(tags.length) && /*#__PURE__*/_react.default.createElement("div", {
    className: 'tag-labels'
  }, tags.map(function (tag) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: tag
    }, tag);
  }))) : false, titlesSecondary ? /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: isCoversSecondaryOpen
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.covers,
    style: {
      maxWidth: 812,
      padding: 20,
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "protection ".concat(mobileOnly())
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'p-title'
  }, "\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05DE\u05D9\u05D2\u05D5\u05DF"), /*#__PURE__*/_react.default.createElement("div", null, data.protectionTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: 'table-title'
  }, "\u05E2\u05D9\u05E7\u05E8\u05D9 \u05DB\u05D9\u05E1\u05D5\u05D9\u05D9\u05DD"), /*#__PURE__*/_react.default.createElement(_SimpleTable.default, {
    className: 'covers-table',
    items: coversSecondary
  }))) : false, /*#__PURE__*/_react.default.createElement("div", {
    className: "offer-footer ".concat(showWhenOpen())
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleCoversClick,
    className: classes.coversButton
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: isCoversOpen ? MinusIcon : LeftArrowIcon,
    className: isCoversOpen ? 'rotate' : '',
    alt: "left-arrow"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'info'
  }, "\u05D4\u05E6\u05D2\u05EA \u05DB\u05D9\u05E1\u05D5\u05D9\u05D9\u05DD \u05D5\u05DE\u05D9\u05D3\u05E2 \u05E0\u05D5\u05E1\u05E3")), showProtectionTitle && data.protectionTitle && !isMobile ? /*#__PURE__*/_react.default.createElement("div", {
    className: simulator ? 'protection-title-simulator' : 'protection-title'
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: data.protectionTitle
  }, /*#__PURE__*/_react.default.createElement("span", null, data.protectionTitle))) : false, tags && Boolean(tags.length) && /*#__PURE__*/_react.default.createElement("div", {
    className: 'tag-labels'
  }, tags.map(function (tag) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: tag
    }, tag);
  })), !simulator && Boolean(data.disclaimer) && /*#__PURE__*/_react.default.createElement("div", {
    className: 'disclaimer'
  }, /*#__PURE__*/_react.default.createElement("span", null, data.disclaimer.length && data.disclaimer.includes('<' && '>') ? /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(data.disclaimer)
    }
  }) : data.disclaimer)), data.showAdditionalInfoPolicy ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      zIndex: 7
    },
    className: 'disclaimer'
  }, /*#__PURE__*/_react.default.createElement("a", {
    style: {
      textDecoration: 'none'
    },
    href: data.additionalInfoPolicyPDFlink,
    target: "_blank",
    rel: "noreferrer"
  }, "\u05D4\u05E8\u05D7\u05D1\u05D5\u05EA \u05D5\u05DB\u05EA\u05D1\u05D9 \u05E9\u05D9\u05E8\u05D5\u05EA")) : null)), !isMobile && !noLeft ? /*#__PURE__*/_react.default.createElement(Left, {
    isDownMB: isDownMB,
    columnsQuantity: data.additionalPrices.length,
    classes: classes
  }, data.additionalPrices.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "additional-prices-".concat(index),
      className: classes.column
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(classes.title, " ").concat(showWhenOpen())
    }, item.title), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.content
    }, displayValue(item.value, currency)));
  })) : false), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: isCoversOpen
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.covers,
    style: {
      maxWidth: 812,
      padding: 20,
      width: '100%'
    }
  }, data.fullDisclosure && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'attention-title'
  }, /*#__PURE__*/_react.default.createElement(_ReportProblemOutlined.default, {
    className: mobileOnly()
  }), ' ', "\u05DC\u05EA\u05E9\u05D5\u05DE\u05EA \u05DC\u05D1\u05DA,"), /*#__PURE__*/_react.default.createElement("span", {
    className: 'attention'
  }, data.fullDisclosure)), /*#__PURE__*/_react.default.createElement("div", {
    className: 'table-title'
  }, "\u05E2\u05D9\u05E7\u05E8\u05D9 \u05DB\u05D9\u05E1\u05D5\u05D9\u05D9\u05DD"), /*#__PURE__*/_react.default.createElement(_SimpleTable.default, {
    className: 'covers-table',
    items: covers
  }), coversExtraPrime !== null && coversExtraPrime !== void 0 && coversExtraPrime.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'table-title'
  }, "\u05DB\u05D9\u05E1\u05D5\u05D9\u05D9\u05DD \u05E0\u05D5\u05E1\u05E4\u05D9\u05DD") : false, coversExtraPrime !== null && coversExtraPrime !== void 0 && coversExtraPrime.length ? /*#__PURE__*/_react.default.createElement(_SimpleTable.default, {
    className: 'covers-table',
    items: coversExtraPrime
  }) : false, /*#__PURE__*/_react.default.createElement("a", {
    href: data.pdfLink,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: 'pdf-button',
    variant: "outlined",
    color: "secondary",
    onClick: pdfLinkHandler
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: PdfFileIcon,
    alt: "pdf-file"
  }), "\u05EA\u05E0\u05D0\u05D9 \u05D4\u05D1\u05D9\u05D8\u05D5\u05D7 \u05D4\u05DE\u05DC\u05D0\u05D9\u05DD")))));
};
var displayValue = function displayValue(value, currency) {
  if (typeof value === 'number') {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value.toLocaleString(), /*#__PURE__*/_react.default.createElement("span", null, function () {
      switch (currency) {
        case 'dollar':
          return '$';
        case 'shekel':
          return '₪';
        case 'empty':
        default:
          return '';
      }
    }()));
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    className: 'string'
  }, value);
};
var Left = function Left(props) {
  var children = props.children,
    _props$isDownMB = props.isDownMB,
    isDownMB = _props$isDownMB === void 0 ? false : _props$isDownMB,
    _props$columnsQuantit = props.columnsQuantity,
    columnsQuantity = _props$columnsQuantit === void 0 ? 2 : _props$columnsQuantit,
    classes = props.classes;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.left,
    style: {
      width: isDownMB ? 75 * columnsQuantity : 120 * columnsQuantity
    }
  }, children);
};
Left.propTypes = {
  children: _propTypes.default.any,
  classes: _propTypes.default.object,
  columnsQuantity: _propTypes.default.number,
  isDownMB: _propTypes.default.bool
};
Offer.propTypes = {
  bestOfferBadgeText: _propTypes.default.string,
  children: _propTypes.default.any,
  closeContactUsHandler: _propTypes.default.func,
  contactUsSubmitHandler: _propTypes.default.func,
  currency: _propTypes.default.string,
  data: _propTypes.default.object.isRequired,
  expandCoversHandler: _propTypes.default.func,
  extraPrimaryCovers: _propTypes.default.bool,
  isBestOffer: _propTypes.default.bool,
  isOpen: _propTypes.default.bool,
  noLeft: _propTypes.default.bool,
  OfferFooterContainer: _propTypes.default.any,
  pdfLinkHandler: _propTypes.default.func,
  purchaseContainer: _propTypes.default.any,
  shouldFilterEmptyCovers: _propTypes.default.bool,
  showContactUs: _propTypes.default.bool,
  showProtectionTitle: _propTypes.default.bool,
  simulator: _propTypes.default.bool,
  tags: _propTypes.default.arrayOf(_propTypes.default.string),
  titles: _propTypes.default.object,
  titlesSecondary: _propTypes.default.array
};
var Close = function Close(_ref8) {
  var className = _ref8.className,
    onClick = _ref8.onClick;
  return /*#__PURE__*/_react.default.createElement("span", {
    role: "button",
    tabIndex: 0,
    className: "".concat(className, " close"),
    onClick: onClick,
    onKeyPress: onClick
  });
};
exports.Close = Close;
Close.propTypes = {
  className: _propTypes.default.string,
  onClick: _propTypes.default.func
};
var _default = exports.default = Offer;